import { create } from "zustand";

export interface BridgeConfig {
  toChainId?: number;
  fromChainId?: number;
  toToken?: string;
  fromToken?: string;
}

interface BridgeModalStore {
  isOpen: boolean;
  bridgeConfig?: BridgeConfig;
  setIsOpen: (open: boolean) => void;
  handleOpen: (config?: BridgeConfig) => void;
  handleClose: () => void;
}

export const useBridgeModalStore = create<BridgeModalStore>((set) => ({
  isOpen: false,
  bridgeConfig: undefined,
  setIsOpen: (open) => set({ isOpen: open, ...(!open && { bridgeConfig: undefined }) }),
  handleOpen: (config) => set({ isOpen: true, bridgeConfig: config }),
  handleClose: () => set({ isOpen: false, bridgeConfig: undefined }),
}));
